import { FormattedMessage } from "react-intl";

const IncidentEscalation = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.incidentEscalation.content.body"
                    defaultMessage="Manage and respond to incoming alerts with routing rules, escalation policies, and on-call schedules."
                />
            </p>
        </div>
    );
};

export default IncidentEscalation;
